import { render, staticRenderFns } from "./LogisticCost3rdPartyCoal.vue?vue&type=template&id=5bcb659f&scoped=true&"
import script from "./LogisticCost3rdPartyCoal.vue?vue&type=script&lang=js&"
export * from "./LogisticCost3rdPartyCoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcb659f",
  null
  
)

export default component.exports